import { Injectable } from '@angular/core';
import moment from 'moment';
import { SharedDataService } from '../../data/services/shared-data.service';

@Injectable({ providedIn: 'root' })
export class TriallerService {
    constructor(private sharedData: SharedDataService) {}

    isTrialler(): boolean {
        return this.sharedData.UserData.tenant.IsTrialAccount;
    }

    isNewAccount(maxDaysAge = 14): boolean {
        const accountCreation: string = this.sharedData.UserData.user.ActivationDate;
        return moment().diff(accountCreation, 'days') <= maxDaysAge;
    }
}
